import { t } from '@lingui/macro'
import { ResourceVersionItemFragment } from './ResourceVersionsTable.codegen'
import { formatDateAndTimeLong } from '../../../utils/dateHelpers'

export const prepareCSVResourceVersionsExport = (data) =>
  data.map((row: ResourceVersionItemFragment & { title: string }) => ({
    [t`Title`]: row.title,
    [t`Version`]: row.version,
    [t`Version description`]: row.publishingMessage,
    [t`Version date`]: row.createdAt,
    [t`Version creator`]: row.publishedByUserName,
    [t`Avg version rating`]: row.avgRating,
    [t`Rating count`]: row.numberRated,
    [t`Version views`]: row.viewsCount,
    [t`Last viewed`]: formatDateAndTimeLong(row.lastViewedAt)
  }))
